/* globals LANG */

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'normalize.css';
import { addTranslationForLanguage, initialize, setActiveLanguage } from 'react-localize-redux';

import Store from './redux/store';
import App from './modules/App';

import { setDefaultsFromLang } from './modules/App/AppState';
import Config from './config';

import './styles/main.styl';

if (module.hot) module.hot.accept();

const countryCode = VERSION_CODE || 'de';
const currentConfig = Config[countryCode];
const currentLang = currentConfig.lang || 'de';
const languages = [currentLang];

Store.dispatch(initialize(languages));
Store.dispatch(setActiveLanguage(currentLang));
Store.dispatch(setDefaultsFromLang(currentConfig));

const content = require(`./public/translations/${countryCode}.json`);

Store.dispatch(addTranslationForLanguage(content, currentLang));

ReactDOM.render(
  <Provider store={Store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js